import equals from "ramda/es/equals";

export function DeepEqual<T1, T2>(source1: T1, source2: T2): boolean {

    return equals<any>(source1, source2);
}
